var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2.914a.5.5 0 0 0-.146-.353L9.5 1.207V5.5A1.5 1.5 0 0 1 8 7H4a1.5 1.5 0 0 1-1.5-1.5V1zm1.5 0h5v4.5A.5.5 0 0 1 8 6H4a.5.5 0 0 1-.5-.5zM0 2a2 2 0 0 1 2-2h7.086a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 12 2.914V10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.5 0v3h1V2z",
    clipRule: "evenodd"
  })));
});
const SvgSavesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDFDMS40NDc3MiAxIDEgMS40NDc3MiAxIDJWMTBDMSAxMC41NTIzIDEuNDQ3NzIgMTEgMiAxMUgxMEMxMC41NTIzIDExIDExIDEwLjU1MjMgMTEgMTBWMi45MTQyMUMxMSAyLjc4MTYxIDEwLjk0NzMgMi42NTQ0MyAxMC44NTM2IDIuNTYwNjZMOS41IDEuMjA3MTFWNS41QzkuNSA2LjMyODQzIDguODI4NDMgNyA4IDdINEMzLjE3MTU3IDcgMi41IDYuMzI4NDMgMi41IDUuNVYxSDJaTTMuNSAxSDguNVY1LjVDOC41IDUuNzc2MTQgOC4yNzYxNCA2IDggNkg0QzMuNzIzODYgNiAzLjUgNS43NzYxNCAzLjUgNS41VjFaTTAgMkMwIDAuODk1NDMxIDAuODk1NDMxIDAgMiAwSDkuMDg1NzlDOS40ODM2MSAwIDkuODY1MTQgMC4xNTgwMzUgMTAuMTQ2NCAwLjQzOTM0TDExLjU2MDcgMS44NTM1NUMxMS44NDIgMi4xMzQ4NiAxMiAyLjUxNjM5IDEyIDIuOTE0MjFWMTBDMTIgMTEuMTA0NiAxMS4xMDQ2IDEyIDEwIDEySDJDMC44OTU0MzEgMTIgMCAxMS4xMDQ2IDAgMTBWMlpNNi41IDEuOTk5ODhWNC45OTk4OEg3LjVWMS45OTk4OEg2LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";